export default {
  welcome: 'こんにちは!',
};
